// 메인과 같은 하단을 쓰는 사이트 페이지 틀 (인트로 · 검사 안내 · 내비두 소개 · 연구보고서)
// 헤더·본문 바로가기는 공통 틀(app/SiteShell)에서 그림 — 화면 이동 때 헤더 고정 (2026-11-01 mid=470)
import type { MouseEvent, ReactNode } from 'react';
import { SiteBottom } from './SiteBottom';
import s from './SiteLayout.module.scss';

export function SiteLayout({ id, children }: { id: string; children: ReactNode }) {
  return (
    <div className={s.page} id={id}>
      <main id="main">{children}</main>
      <SiteBottom />
    </div>
  );
}

/** 본문 바로가기 — 헤더 앞 첫 링크 · 화면마다 다른 본문(main) 으로 이동 */
export function SiteSkipLink() {
  const go = (e: MouseEvent) => {
    const main = document.querySelector('main');
    if (!main) return;
    e.preventDefault();
    if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
    main.focus();
  };
  return <a id="link-site-layout-skip" className={s.skip} href="#main" onClick={go}>본문 바로가기</a>;
}
